import React from "react";
import { useForm } from "react-hook-form";
import { useUpdateEvaluationForm } from "./logic/useEvaluationForm";
import { message } from "antd";
import './EditFormComponent.scss';
const EditFormComponent = ({ form, onClose, onUpdated }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: form.title,
      year: form.year,
      description: form.description,
    },
  });

  const { mutate, isLoading } = useUpdateEvaluationForm();

  const onSubmit = (data) => {
    mutate(
      { id: form.id, ...data },
      {
        onSuccess: () => {
          message.success("Form updated!");
          onUpdated?.();
        },
        onError: (err) => {
          message.error(err?.response?.data?.message || "Update failed");
        },
      }
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form-creator">
      <div className="form-field">
        <label>Title</label>
        <input {...register("title", { required: "Title is required" })} />
        {errors.title && <span className="error">{errors.title.message}</span>}
      </div>

      <div className="form-field">
        <label>Year</label>
        <input
          type="number"
          {...register("year", {
            required: "Year is required",
            min: { value: 2000, message: "Year must not be less than 2000" },
            valueAsNumber: true,
          })}
        />

        {errors.year && <span className="error">{errors.year.message}</span>}
      </div>

      <div className="form-field col-span">
        <label>Description</label>
        <textarea
          {...register("description", { required: "Description is required" })}
          rows={3}
        />
        {errors.description && (
          <span className="error">{errors.description.message}</span>
        )}
      </div>

      <div className="form-submit">
        <button type="button" onClick={onClose}>
          Cancel
        </button>
        <button type="submit" disabled={isLoading}>
          {isLoading ? "Updating..." : "Update Form"}
        </button>
      </div>
    </form>
  );
};

export default EditFormComponent;
